import logo from "./logo.svg";
import "./App.css";
import NotePage from "./pages/NotePage";

function App() {
  return <NotePage></NotePage>;
}

export default App;
